import { Box, Grid, Spinner } from '@chakra-ui/react';
import { FC } from 'react';

import { SalesSource } from '../../types';
import { SectionCard } from './section-card';

type SalesSourcesSectionProps = {
  salesSources: SalesSource[];
  isLoading: boolean;
};

const HeaderCell = ({ children }: { children: string }) => (
  <Box
    fontSize="11.5px"
    fontWeight={700}
    letterSpacing=".03em"
    color="#98a2b0"
    textTransform="uppercase"
  >
    {children}
  </Box>
);

export const SalesSourcesSection: FC<SalesSourcesSectionProps> = ({
  salesSources,
  isLoading,
}) => (
  <SectionCard title="Список источников продаж" badge="только для чтения">
    {isLoading ? (
      <Box display="flex" justifyContent="center" py={6}>
        <Spinner />
      </Box>
    ) : (
      <>
        <Grid templateColumns="1fr 1fr" gap={2} px={6} pb={2}>
          <HeaderCell>Источник</HeaderCell>
          <HeaderCell>ID ТТ источника продаж</HeaderCell>
        </Grid>
        {salesSources.length === 0 ? (
          <Box px={6} py={4} borderTop="1px solid #eef1f5" fontSize="14px" color="#8a94a3">
            Нет данных
          </Box>
        ) : (
          salesSources.map((item, index) => (
            <Grid
              key={`${item.source.id}-${item.sales_outlet_id}-${index}`}
              templateColumns="1fr 1fr"
              gap={2}
              px={6}
              py={3.5}
              borderTop="1px solid #eef1f5"
            >
              <Box fontSize="14px" color="#3a4150" wordBreak="break-all">
                {item.source.name}
              </Box>
              <Box fontSize="14px" color="#3a4150">
                {item.sales_outlet_id}
              </Box>
            </Grid>
          ))
        )}
      </>
    )}
  </SectionCard>
);
